import { PortalAuthHttpError } from '../error';
import { PortalApiClient } from '../portalApiClient';

import { getMessageFromError } from './errorHelper';
import { LoginResponse } from './types';

export async function login(
  email: string,
  password: string,
  client: PortalApiClient
): Promise<LoginResponse> {
  try {
    const { data, error, response } = await client.untyped.POST(
      '/api/v1/login',
      {
        body: { email, password },
      }
    );
    if (!response.ok) {
      const message = getMessageFromError(error);
      throw new PortalAuthHttpError(
        message ?? 'Your login credentials are invalid.',
        response.status
      );
    }
    return LoginResponse.parse(data);
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
